



















import { Vue, Component, Prop } from 'vue-property-decorator';
import Quadrant from '@/domain/matrix-config/entity/quadrant.entity';

@Component({})
export default class QuadrantComponent extends Vue {
  @Prop({ type: Quadrant, required: true })
  quadrant!: Quadrant;

  @Prop({ type: Boolean, default: false })
  selected!: boolean;

  onClick() {
    this.$emit('click');
  }
}
